<a routerLink="/product-info/{{product.tag}}" class="product-card" (click)="openInfo(product)">

  <div *ngIf="!product.isNew && product.isPopular" class="sticker popular">
    Хит!
  </div>
  <div *ngIf="product.isNew" class="sticker new">
    Новинка!
  </div>
  <div *ngIf="product.availability.status == 'expected'" class="sticker popular">
    Скоро!
  </div>
  <div *ngIf="!product.isNew && !product.isPopular" class="sticker new" style="visibility: hidden" >normal
   </div>
  <div class="product-card-image">

    <ng-template #noImageFound>
      <img src="../assets/not_found.png" class="image-not-found"/>
    </ng-template>


    <div *ngIf="productImage; else noImageFound"   class="image-wrapper">
      <image [imageLink]="productImage"></image>

    </div>


  </div>
  <div class="product-card-info">
    <div class="product-card-name">{{product.name}}</div>
    <div class="product-card-author">{{product.author}}</div>

    <div class="product-card-price">

      <span *ngIf="product.discount" class="discount"> {{product.retailPriceEuro + ' \u20AC'}}</span>
      {{product.discountPriceEuro + ' \u20AC'}}
    </div>

  </div>

</a>
<button mat-button class="main-button to-cart "
        (click)="addToCart()"
        [disabled]="countInCart > 0 && product.availability.status == 'in_stock'"
>В корзину
</button>
